<template>
    <Layout>

        <div class="row">

            <Talks
                @reset-page="resetPage"
            />

            <div class="col-sm-8" v-if="mentee || activeMentoring" data-testid="chat-panel">
                <div class="card" style="height: calc(100vh - 110px)">
                    <div class="card-header">
                        <div class="card-title d-flex" v-if="activeMentoring" data-testid="group-chat-header">
                            <img v-if="activeMentoring.logoUrl" height="40" :src="activeMentoring.logoUrl"
                                 class="rounded-circle" :alt="activeMentoring.title"/>
                            <div v-else
                                 class="rounded-circle d-flex align-items-center justify-content-center bg-light"
                                 style="width: 40px; height: 40px;">
                                <i class="fa fa-users text-muted"></i>
                            </div>
                            <div class="my-auto ml-3">
                                <span data-testid="group-chat-title">{{ activeMentoring.title }}</span>
                                <br>
                                <small class="text-muted">{{ activeCohort && activeCohort.name ? activeCohort.name : 'Chat da turma' }}</small>
                            </div>
                        </div>
                        <div class="card-title d-flex" v-else data-testid="direct-chat-header">
                            <img height="40" :src="`${env.url}mentees/image/${mentee.id}`" class="rounded-circle"
                                 alt="Perfil Mentorando"/>
                            <span class="my-auto ml-3">{{ mentee.name }}</span>
                        </div>
                    </div>

                    <div class="border-bottom p-3 mb-3 custom-scroll" id="chat" ref="scrollContainer"
                         :style="{ backgroundImage: 'url(' + require('../../assets/images/chat.png') + ')' }"
                         style="overflow-y: auto; height: calc(100vh - 190px);" @scroll="handleScroll"
                         data-testid="chat-messages">
                        <template v-if="activeMentoring">
                            <div v-if="groupMessages.length > 0">
                                <div class="row" v-for="(msg, index) in groupMessages"
                                     :key="'group-message-' + msg.id">
                                    <div class="col">
                                        <div class="row" v-if="verifyGroupDates(index)">
                                            <div class="col text-center my-3">
                                                <span class="bg-light p-2">{{ getDate(msg.created_at) }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <span class="p-3 my-1 message"
                                                      :class="isOwnGroupMessage(msg) ? 'bg-light' : 'bg-success'">
                                                    <strong v-if="!isOwnGroupMessage(msg)" class="d-block mb-1"
                                                            style="font-size: 12px;">
                                                        {{ msg.sender_name }}
                                                    </strong>
                                                    {{ msg.message }}<br>
                                                    <span class="hour text-muted"
                                                          :class="isOwnGroupMessage(msg) ? 'float-right' : ''">
                                                        {{ formatHour(msg.created_at) }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col text-center my-3">
                                        <span class="bg-light p-2">Sem mensagens até o momento</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-if="messages.data.length > 0">
                                <div class="row" v-for="(message, index) in messages.data"
                                     :key="'message' + message.id">
                                    <div class="col">
                                        <div class="row" v-if="verifyDates(index)">
                                            <div class="col text-center my-3">
                                                <span class="bg-light p-2">{{ getDate(message.created_at) }}</span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <span class="p-3 my-1 message"
                                                      :class="message.target === 'mentee' ? 'bg-light' : 'bg-success'">
                                                    {{ message.message }}<br>
                                                    <span class="hour text-muted"
                                                          :class="message.target === 'mentee' ? 'float-right' : ''">
                                                        {{ formatHour(message.created_at) }}
                                                        <i class="fa fa-check-circle ml-1"
                                                           v-if="message.target === 'mentee'"
                                                           :class="message.read_at  ? 'text-success' : 'text-muted'"></i>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col text-center my-3">
                                        <span class="bg-light p-2">Sem mensagens até o momento</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <form id="form" @submit.prevent="activeMentoring ? newGroupMessage() : newMessage()">
                        <div class="row px-3">
                            <div class="col d-flex mb-3">
                                <div class="bv-no-focus-ring my-auto w-100">
                                    <div role="group" class="input-group input-group-merge form-control-prepended">
                                        <input placeholder="Digite a nova mensagem..." v-model="message"
                                               class="form-control form-control-appended"
                                               data-testid="chat-message-input">
                                        <div class="input-group-append">
                                            <button type="submit" class="input-group-text bg-success text-white"
                                                    data-testid="chat-send-button">
                                                <i class="fa fa-paper-plane"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>


    </Layout>
</template>

<script>

import Layout from '@/components/layout/main.vue';
import Talks from "@/views/chat/talks.vue";
import http from '@/http';
import env from '@/env';
import {formatHour, getDate, isSameDay} from "@/components/composables/masks";
import {debounce} from 'lodash';

export default {
    data() {
        return {
            messages: {
                data: []
            },
            groupMessages: [],
            load: true,
            addChat: false,
            message: "",
            username: "Steven Franklin",
            profile: require("@/assets/images/people/110/guy-1.jpg"),
            mentee: null,
            activeMentoring: null,
            activeCohort: null,
            groupChannelName: null,
            page: 1,
            search: '',
            listFiltered: [],
            listTotalMentees: [],
            searchTotalMentees: [],
            env,
            observer: null,
            isWindowActive: true,
            isChatVisible: false,
            focusHandler: null,
            blurHandler: null
        };
    },
    components: {
        Layout,
        Talks
    },

    methods: {
        formatHour,
        getDate,

        isOwnGroupMessage(msg) {
            return msg.sender_type === 'mentor' && Number(msg.sender_id) === Number(this.currentUser.id);
        },

        newMessage() {
            if (this.message === '') {
                return;
            }

            const formData = {
                mentor_id: this.currentUser.id,
                message: this.message,
                mentee_id: this.mentee.id,
                target: 'mentee'
            }

            http.post('mentor/messages/save', formData)
                .then(() => {
                    this.message = '';
                })
                .catch(() => {
                    this.$notifyError(null, 'Erro ao enviar Mensagem!');
                });
        },

        newGroupMessage() {
            if (this.message === '' || !this.activeMentoring || !this.activeCohort) {
                return;
            }

            const formData = {
                mentoring_id: this.activeMentoring.id,
                cohort_id: this.activeCohort.id,
                message: this.message,
            };

            http.post('group-messages', formData)
                .then((response) => {
                    this.message = '';
                    this.appendGroupMessage(response.data);
                })
                .catch(() => {
                    this.$notifyError(null, 'Erro ao enviar Mensagem!');
                });
        },

        appendGroupMessage(msg) {
            if (!msg || !msg.id) return;
            if (this.groupMessages.some(m => Number(m.id) === Number(msg.id))) {
                return;
            }
            this.groupMessages.push(msg);
            this.scrollToBottom();
        },

        handleScroll(event) {
            if (this.activeMentoring) {
                return;
            }
            if (event.target.scrollTop === 0 && this.load && this.messages.count > this.page * 20) {
                this.load = false;
                ++this.page;
                this.debouncedGetMessages(this.mentee.id);
            }
        },

        leaveGroupChannel() {
            if (window.Echo && this.groupChannelName) {
                window.Echo.leave(this.groupChannelName);
                this.groupChannelName = null;
            }
        },

        subscribeGroupChannel(cohortId) {
            this.leaveGroupChannel();
            if (!(window.Echo && env.pusher_enabled) || !cohortId) {
                return;
            }
            const channelName = 'group-chat.' + cohortId;
            this.groupChannelName = channelName;
            window.Echo.private(channelName)
                .listen('.group.message.sent', (e) => {
                    if (!this.activeCohort) return;
                    if (Number(e.cohort_id) === Number(this.activeCohort.id)) {
                        this.appendGroupMessage(e);
                    }
                });
        },

        async openGroupChat(mentoring, cohort) {
            this.leaveGroupChannel();
            this.mentee = null;
            this.activeMentoring = mentoring;
            this.activeCohort = cohort || null;
            this.messages = {data: []};
            this.groupMessages = [];
            this.page = 1;
            if (!this.activeCohort || !this.activeCohort.id) {
                this.$notifyError('Turma não informada para o chat.');
                return;
            }
            await this.getGroupMessages(this.activeCohort.id);
            this.subscribeGroupChannel(this.activeCohort.id);
        },

        async openDirectChat(menteeId) {
            this.leaveGroupChannel();
            this.activeMentoring = null;
            this.activeCohort = null;
            this.groupMessages = [];
            this.page = 1;
            this.messages = {data: []};
            await this.getMessages(menteeId);
            this.markMessagesAsRead();
        },

        async resetPage(payload) {
            if (payload && typeof payload === 'object' && payload.type === 'group') {
                await this.openGroupChat(payload.mentoring, payload.cohort);
                return;
            }
            const menteeId = payload && typeof payload === 'object'
                ? payload.menteeId
                : payload;
            await this.openDirectChat(menteeId);
        },

        verifyDates(index) {
            if (index === 0) {
                return true;
            } else {
                const before = this.messages.data[index - 1];
                const data = this.messages.data[index];
                const date1 = new Date(before.created_at);
                const date2 = new Date(data.created_at);
                return !isSameDay(date2, date1);
            }
        },

        verifyGroupDates(index) {
            if (index === 0) {
                return true;
            }
            const before = this.groupMessages[index - 1];
            const data = this.groupMessages[index];
            const date1 = new Date(before.created_at);
            const date2 = new Date(data.created_at);
            return !isSameDay(date2, date1);
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.scrollContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },

        getGroupMessages(cohortId) {
            return http.get('group-messages', {params: {cohort_id: cohortId}})
                .then(response => {
                    const list = Array.isArray(response.data) ? response.data : [];
                    this.groupMessages = list.slice().sort((a, b) => {
                        const ta = new Date(a.created_at).getTime();
                        const tb = new Date(b.created_at).getTime();
                        if (ta !== tb) return ta - tb;
                        return Number(a.id) - Number(b.id);
                    });
                    if (this.groupMessages.length > 0) {
                        this.scrollToBottom();
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$notifyError(e.response?.data || null, 'Erro ao carregar chat da turma!');
                });
        },

        getMessages(id) {
            if (!id) return;
            
            http.get(`mentor/get-messages/${id}?page=${this.page}`)
                .then(response => {
                    if (this.page === 1) {
                        this.mentee = response.data.mentee;
                        const newValue = response.data.messages;
                        newValue.data.sort((a, b) => a.id - b.id);
                        this.messages = newValue;
                        if (this.messages.data.length > 0) {
                            this.scrollToBottom();
                        }
                        this.markMessagesAsRead();
                    } else {
                        const container = this.$refs.scrollContainer;
                        if (container) {
                            const scrollHeightBefore = container.scrollHeight;

                            response.data.messages.data.sort((a, b) => a.id - b.id);
                            this.messages.data = [
                                ...response.data.messages.data,
                                ...this.messages.data,
                            ];

                            this.$nextTick(() => {
                                if (container) {
                                    const scrollHeightAfter = container.scrollHeight;
                                    container.scrollTop = scrollHeightAfter - scrollHeightBefore;
                                }
                            });
                        }
                    }
                    this.load = true;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        markMessagesAsRead() {
            if (this.mentee) {
                http.post('mentor/messages/mark-read', {
                    mentee_id: this.mentee.id
                }).then(() => {
                    this.$store.commit('api/markAsRead');
                    http.get('mentor/messages/chat-data')
                        .then(response => {
                            this.$store.commit('api/setMessages', response.data);
                        })
                        .catch(e => {
                            console.error('Erro ao atualizar lista de mensagens:', e);
                        });
                }).catch(e => {
                    console.error('Erro ao marcar mensagens como lidas:', e);
                });
            }
        },

        handleVisibilityChange() {
            if (document.visibilityState === 'visible' && this.mentee) {
                this.markMessagesAsRead();
            }
        },

        handleWindowFocus() {
            this.isWindowActive = true;
            if (this.isChatVisible && this.mentee) {
                this.markMessagesAsRead();
            }
        },

        handleWindowBlur() {
            this.isWindowActive = false;
        },

        handleIntersection(entries) {
            entries.forEach(entry => {
                this.isChatVisible = entry.isIntersecting;
                if (entry.isIntersecting && this.isWindowActive && this.mentee) {
                    this.markMessagesAsRead();
                }
            });
        }
    },
    mounted() {
        document.getElementById('footer').style.display = 'none';
        const id = this.$route.params.id;
        const cohortId = this.$route.query.cohort || this.$route.query.group;
        const mentoringId = this.$route.query.mentoring;
        if (cohortId) {
            this.openGroupChat(
                {id: mentoringId ? Number(mentoringId) : null, title: 'Chat da turma'},
                {id: Number(cohortId), name: 'Chat da turma'}
            );
        } else if (id) {
            this.getMessages(id);
        }
        
        if (window.Echo && env.pusher_enabled) {
            window.Echo.channel('chat')
                .listen('.message.sent', (e) => {
                    if (this.activeMentoring || !this.mentee) return;
                    if (e.message.mentor_id === this.currentUser.id && e.message.mentee_id === this.mentee.id) {
                        this.messages.data.push(e.message);
                        this.scrollToBottom();
                    }
                })
                .listen('.message.read', (e) => {
                    if (this.activeMentoring || !this.mentee) return;
                    if (e.mentor_id === this.currentUser.id && e.mentee_id === this.mentee.id) {
                        this.messages.data = this.messages.data.map(message => ({
                            ...message,
                            read_at: message.read_at || new Date().toISOString()
                        }));
                    }
                });
        }

        // Adiciona listeners para detectar quando a janela está ativa/inativa
        window.addEventListener('focus', () => {
            this.isWindowActive = true;
            if (this.mentee) {
                this.markMessagesAsRead();
            }
        });

        window.addEventListener('blur', () => {
            this.isWindowActive = false;
        });

        // Configura o IntersectionObserver para detectar quando o chat está visível
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                this.isChatVisible = entry.isIntersecting;
                if (entry.isIntersecting && this.mentee) {
                    this.markMessagesAsRead();
                }
            });
        }, { threshold: 0.5 });

        // Observa o container do chat
        this.$nextTick(() => {
            const chatContainer = document.getElementById('chat');
            if (chatContainer) {
                observer.observe(chatContainer);
            }
        });
    },
    beforeDestroy() {
        this.leaveGroupChannel();
        window.removeEventListener('focus', () => {});
        window.removeEventListener('blur', () => {});
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    created() {
        this.debouncedGetMessages = debounce((id) => {
            this.getMessages(id);
        }, 500);
    },
};
</script>

<style scoped>
.item-chat:hover {
    background: #F5F7FA !important;
}

.page-section .form-control:focus {
    box-shadow: none !important;
    border-bottom: solid 1px #DBDBE0 !important;
    border-radius: 0 !important;
}

.max {
    width: 60%;
}

span.bg-light.message {
    border-radius: 8px;
    max-width: 75%;
    float: right;
}

span.bg-success.message {
    border-radius: 8px;
    max-width: 75%;
    float: left;
//background: #a3ff75!important; background: #c4fca9 !important;
}

.hour {
    font-size: 10px;
    font-style: italic;
    margin: 0 10px;
}

.op-0 {
    opacity: 0;
}

.hidden {
    visibility: hidden;
}

</style>
